export default Object.freeze({
  TopStart: 1,
  TopMiddle: 2,
  TopEnd: 3,
  CenterStart: 4,
  CenterMiddle: 5,
  CenterEnd: 6,
  BottomStart: 7,
  BottomMiddle: 8,
  BottomEnd: 9,
});
